import { HALF_EQUATOR, SUBEQUATOR } from './constants';
import { toMercator } from './mercator';

export function toGlobalPixels(point: YMaps.TCoord, zoom: number): YMaps.TPixelCoord {
  const pixelsPerMeter = Math.pow(2, zoom + 8) * SUBEQUATOR;
  const mercatorCoords = toMercator(point);

  return [(HALF_EQUATOR + mercatorCoords[0]) * pixelsPerMeter, (HALF_EQUATOR - mercatorCoords[1]) * pixelsPerMeter];
}
